// extracted by mini-css-extract-plugin
export default {"logo-redes-sociales":"ContenedorRedes_logo-redes-sociales__HJpjt"};